import TriggersCreatedPage from './TriggersCreatedPage';

export default TriggersCreatedPage;